module.exports = __webpack_public_path__ + "img/honor1.e128621f.jpg";